export const SAVE = 'stepBaggageAndPersonalItems.SAVE';
export const VALUE_CHANGED = 'stepBaggageAndPersonalItems.VALUE_CHANGED';
export const LOAD = 'stepBaggageAndPersonalItems.VALUE_LOAD';
export const NEXT = 'stepBaggageAndPersonalItems.NEXT';
export const RESET = 'stepBaggageAndPersonalItems.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'stepBaggageAndPersonalItems.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'stepBaggageAndPersonalItems.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'stepBaggageAndPersonalItems.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'stepBaggageAndPersonalItems.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'stepBaggageAndPersonalItems.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_TRAVEL_DELAY_STATE = 'stepBaggageAndPersonalItems.RESET_TRAVEL_DELAY_STATE';
//------------------------------------------------------
export const RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE = 'stepBaggageAndPersonalItems.RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE';
export const RESET_FOR_BAGGAGE_DELAY_STATE = 'stepBaggageAndPersonalItems.RESET_TRAVEL_INTERRUPTION_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '19',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepBaggageAndPersonalItems/constants.js